import { Controller } from '@hotwired/stimulus'

// Selector por tipo de la portada de cuentas (ENH-RNK-7023). Las tres listas ya están en
// el HTML: elegir una pestaña muestra su lista y oculta las otras, sin cambiar la URL.
//
// - La píldora azul se desliza bajo la pestaña activa y se estira: el borde que va delante
//   sale antes y el de detrás le sigue con un retraso (clases is-hacia-*).
// - Tras un cambio, las tarjetas entran en escalera (clase is-entrando).
// - La barra queda fija arriba al recorrer la lista: con is-pegada pinta un borde para no
//   perderse sobre las tarjetas, y con is-oculta se esconde cuando llega la última tarjeta.
// - Si se cambia de pestaña con la barra pegada, se vuelve al principio de la lista.
// - Es un `tablist`: solo la pestaña activa entra en el orden de tabulación y las flechas (más
//   Inicio y Fin) pasan a la anterior o a la siguiente, la eligen y le dan el foco.
export default class extends Controller {
  static targets = ['barra', 'pildora', 'pestana', 'lista']
  static values = { activa: Number }

  connect () {
    this.sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)')
    this.alHacerScroll = this.alHacerScroll.bind(this)
    window.addEventListener('scroll', this.alHacerScroll, { passive: true })
    window.addEventListener('resize', this.alHacerScroll, { passive: true })
    this.alHacerScroll()
  }

  disconnect () {
    window.removeEventListener('scroll', this.alHacerScroll)
    window.removeEventListener('resize', this.alHacerScroll)
  }

  elegir (evento) {
    this.activar(this.pestanaTargets.indexOf(evento.currentTarget))
  }

  teclado (evento) {
    const total = this.pestanaTargets.length
    const destinos = {
      ArrowLeft: (this.activaValue - 1 + total) % total,
      ArrowRight: (this.activaValue + 1) % total,
      Home: 0,
      End: total - 1
    }
    const indice = destinos[evento.key]
    if (indice === undefined) return

    evento.preventDefault()
    this.activar(indice)
    this.pestanaTargets[indice].focus()
  }

  activar (nueva) {
    if (nueva === this.activaValue) return

    const pegada = this.barraTarget.classList.contains('is-pegada')
    this.element.classList.toggle('is-hacia-izquierda', nueva < this.activaValue)
    this.activaValue = nueva
    this.listaTargets[nueva].classList.add('is-entrando')
    if (pegada) this.volverAlPrincipio()
  }

  activaValueChanged (activa) {
    this.element.dataset.pestanaActiva = activa
    this.pestanaTargets.forEach((pestana, indice) => {
      pestana.classList.toggle('is-activa', indice === activa)
      pestana.setAttribute('aria-selected', indice === activa)
      pestana.tabIndex = indice === activa ? 0 : -1
    })
    this.listaTargets.forEach((lista, indice) => { lista.hidden = indice !== activa })
    this.alHacerScroll()
  }

  volverAlPrincipio () {
    const lista = this.listaTargets[this.activaValue]
    const y = window.scrollY + lista.getBoundingClientRect().top - this.barraTarget.getBoundingClientRect().bottom - 16
    window.scrollTo({ top: Math.max(0, y), behavior: this.sinMovimiento.matches ? 'auto' : 'smooth' })
  }

  alHacerScroll () {
    const barra = this.barraTarget
    const caja = barra.getBoundingClientRect()
    const tope = parseFloat(getComputedStyle(barra).top) || 0
    barra.classList.toggle('is-pegada', caja.top <= tope + 0.5)

    const tarjetas = this.listaTargets[this.activaValue]?.querySelectorAll('.rnk-ProductComparerCard') || []
    const ultima = tarjetas[tarjetas.length - 1]
    barra.classList.toggle('is-oculta', !!ultima && ultima.getBoundingClientRect().top <= caja.bottom)
  }
}
